import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 方位指定（２点入力）操作方法・ダイアログ
 */
class CompassPointInputDialog extends Dialog {
  // eslint-disable-next-line indent
    /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    const id = 'dialogCompassPointInput';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Input 2 points that make an angle'; break;
      default: title = '方位を2点から入力'; break;
    }

    let contents = '';
    // 説明画面
    contents += '<div><span class="jp">角度の分かる２点を入力してください。</span><span class="en">Click 2 reference points on the picture.</span></div>\n';
    contents += `<div style="width: 300px; height:200px"><img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}/description_compassPoint.jpg" style="position: absolute; width: 300px; height:200px" id="arrowImg"></div>`;

    let footer = '';
    footer = '<button value="true"><span>入力する</span></button>';
    footer += '<button value="false"><span>キャンセル</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((elem) => {
      elem.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e: Event) => {
      e.preventDefault();

      switch ((e.currentTarget as HTMLButtonElement).value) {
        case 'true': // キャンセル
          marietta.webcad.WebCADGlobal.itemManager.itemController = new marietta.webcad.control.ItemControllerCompassPointInput();
          this.close();
          break;
        case 'false': // はい
          this.close();
          break;
        default:
          break;
      }
    }
}

export default CompassPointInputDialog;
